// The brand this page is on (@filmsquare/brand: the hostname decides).
import { brandForHost } from "@filmsquare/brand";

export const BRAND = brandForHost(typeof location === "undefined" ? "" : location.hostname);

/**
 * The tab's title and icons. The Worker already serves index.html with them; this covers the routes it does not
 * rewrite and a server without that step.
 */
export function applyBrand(doc: Document = document): void {
  doc.title = BRAND.name;
  const set = (selector: string, href: string) => {
    doc.querySelector<HTMLLinkElement>(selector)?.setAttribute("href", href);
  };
  set('link[rel="icon"][sizes]', BRAND.icons.ico);
  set('link[rel="icon"][type="image/svg+xml"]', BRAND.icons.svg);
  set('link[rel="apple-touch-icon"]', BRAND.icons.apple);
}

/** The brand's typefaces, for its sign-in screen. */
export function loadBrandFonts(doc: Document = document): void {
  const href = BRAND.login?.fonts;
  if (!href || doc.querySelector(`link[href="${href}"]`)) return;
  const link = doc.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  doc.head.append(link);
}

/** The sign-in video runs for people who can see it and do not mind it: not on a phone, under reduced motion or Save-Data. */
export function loginVideoWanted(win: Window = window): boolean {
  const connection = (win.navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  return (
    !!BRAND.login?.video.length &&
    win.matchMedia("(min-width: 901px)").matches &&
    !win.matchMedia("(prefers-reduced-motion: reduce)").matches &&
    !connection?.saveData
  );
}
